import { LegislationSocialSecurityCostSTO } from "src/models/legislation-social-security-cost/legislation-social-security-cost-sto";
import { LegislationsSocialSecurityCostDTO } from "src/models/legislation-social-security-cost/legislations-social-security-cost-dto";
import { BaseApiService } from "../base";

export class LegislationSocialSecurityCostApiService extends BaseApiService<
  LegislationsSocialSecurityCostDTO,
  LegislationSocialSecurityCostSTO
> {
  constructor() {
    super({
      servicePath: "/LegislationSocialSecurityCosts",
      loadItemsPath: "/GetLegislationSocialSecurityCosts",
      saveItemsPath: "/SaveLegislationSocialSecurityCosts",
    });
  }
}
